import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  comparingProducts: [],
  comparisonProductData: null,
  comparisonCategory: '',
  comparisonMode: false,
  isOpenCompareBottomAction: false,
  isOpenCannotBeAddedModal: {
    status: false,
    data: '',
  },
  isOpenClearComparisonListModal: false,
  isMinimizeCompareAction: false,
  comparisonPopups: {
    isSuccess: false,
    message: '',
    isShow: false,
  },
  lastVisitedUrl: null,
};

// Slice
const productComparisonSlice = createSlice({
  name: 'comparison',
  initialState,
  reducers: {
    resetProductComparisonForCache: () => initialState,
    updateComparisonCategory: (state, action) => {
      const { category, mode } = action.payload;
      return {
        ...state,
        comparisonCategory: category,
        comparisonMode: mode,
      };
    },

    updateLastVisitedUrlState: (state, action) => ({
      ...state,
      lastVisitedUrl: action.payload,
    }),

    updateIsOpenCompareBottomActionState: (state, action) => ({
      ...state,
      isOpenCompareBottomAction: action.payload,
    }),

    updateIsOpenCannotBeAddedModalState: (state, action) => {
      const { status, data } = action.payload;
      return {
        ...state,
        isOpenCannotBeAddedModal: {
          ...state.isOpenCannotBeAddedModal,
          status,
          data,
        },
      };
    },

    updateIsOpenClearComparisonListModalState: (state, action) => ({
      ...state,
      isOpenClearComparisonListModal: action.payload,
    }),

    updateIsMinimizeCompareActionState: (state, action) => ({
      ...state,
      isMinimizeCompareAction: action.payload,
    }),

    addToCompare: (state, action) => {
      const product = action.payload;
      const existingProductIndex = state.comparingProducts.findIndex(
        (p) => p.id === product.id,
      );

      if (existingProductIndex === -1) {
        state.comparingProducts.push({ ...product });
      }
    },

    updateComparisonPopupState: (state, action) => {
      const { isSuccess, message, isShow } = action.payload;
      return {
        ...state,
        comparisonPopups: {
          ...state.comparisonPopups,
          isSuccess,
          message,
          isShow,
          isBottom: false,
        },
      };
    },

    removeFromComparisonList: (state, action) => {
      const id = action.payload;
      const updatedProducts = state.comparingProducts.filter(
        (product) => product.id !== id,
      );

      if (updatedProducts.length === 0) {
        return {
          ...state,
          comparingProducts: updatedProducts,
          comparisonPopups: {
            isSuccess: false,
            message: '',
            isShow: false,
            isBottom: false,
          },
          isOpenCompareBottomAction: false,
          isOpenCannotBeAddedModal: {
            status: false,
            data: '',
          },
          isOpenClearComparisonListModal: false,
          isMinimizeCompareAction: false,
          comparisonMode: false,
          comparisonCategory: '',
        };
      }

      return {
        ...state,
        comparingProducts: updatedProducts,
      };
    },

    clearComparisonList: (state) => ({
      ...state,
      comparingProducts: [],
      isOpenCompareBottomAction: false,
      isOpenCannotBeAddedModal: {
        status: false,
        data: '',
      },
      isOpenClearComparisonListModal: false,
      comparisonMode: false,
      isMinimizeCompareAction: false,
      comparisonCategory: '',
      comparisonPopups: {
        isSuccess: false,
        message: '',
        isShow: false,
      },
    }),

    removeFromComparisonTable: (state, action) => {
      const id = action.payload;
      const updatedProducts = state.comparingProducts.filter(
        (product) => product.id !== id,
      );

      if (updatedProducts.length === 1) {
        return {
          ...state,
          comparingProducts: [],
          comparisonPopups: {
            isSuccess: false,
            message: '',
            isShow: false,
            isBottom: false,
          },
          isOpenCompareBottomAction: false,
          isOpenCannotBeAddedModal: {
            status: false,
            data: '',
          },
          isOpenClearComparisonListModal: false,
          isMinimizeCompareAction: false,
          comparisonMode: false,
          comparisonCategory: '',
        };
      }

      return {
        ...state,
        comparingProducts: updatedProducts,
      };
    },
  },
});

export const {
  addToCompare,
  removeFromProducts,
  clearComparisonProducts,
  updateComparisonCategory,
  updateIsOpenCompareBottomActionState,
  updateComparisonPopupState,
  updateIsOpenCannotBeAddedModalState,
  clearComparisonList,
  removeFromComparisonList,
  updateIsMinimizeCompareActionState,
  removeFromComparisonTable,
  resetProductComparisonForCache,
  updateLastVisitedUrlState,
  updateIsOpenClearComparisonListModalState,
} = productComparisonSlice.actions;

export default productComparisonSlice.reducer;
